import { downloadCSV } from 'react-admin';
import type { ClicksByReferrersResource } from '../../../../Entities/ClicksByReferrer';
import type { RegionResource } from '../../../../Entities/Region';
import { idFrom, isNonEmptyString, isNumericString } from '../../../../utils';
import { escapeCsv, getReportDateLabels } from '../../../../Components/ReportsWidget/utils';
import type { ReportFilter } from '../../../../Components/ReportsWidget/utils';

export interface PrefetchedData {
  clicks_by_referrers?: ClicksByReferrersResource[];
  regions?: RegionResource[];
}

export function getClicksByReferrerReportParams(filter: ReportFilter) {
  if (!isNonEmptyString(filter.greaterOrEqual?.date)) {
    throw new Error('Clicks by referrer report requires `from` date');
  }
  if (!isNonEmptyString(filter.lessOrEqual?.date)) {
    throw new Error('Clicks by referrer report requires `to` date');
  }
  const regionIds = filter.region_ids?.filter(isNumericString).map(Number);
  return {
    from: filter.greaterOrEqual.date,
    to: filter.lessOrEqual.date,
    regionIds: regionIds?.length ? regionIds : undefined,
  };
}

export function downloadClicksByReferrersCsv(
  records: ClicksByReferrersResource[],
  prefetched: PrefetchedData,
  filter: ReportFilter,
): void {
  const { startDate, endDate } = getReportDateLabels(filter);

  const header = [
    'Region',
    'Refname',
    'Start Date',
    'End Date',
    'Chargeable Clicks',
    'Non-Chargeable Clicks',
    'CPC',
    'Gross Revenue',
    'Net Revenue',
  ].join(',');

  const rows = records.map((record) => {
    const attrs = record.attributes ?? {};
    const region = prefetched.regions?.find((r) => r.id === idFrom(record, 'region'));

    return [
      escapeCsv(region?.attributes?.name),
      escapeCsv(attrs.refname),
      escapeCsv(startDate),
      escapeCsv(endDate),
      attrs.chargeable_clicks ?? '',
      attrs.non_chargeable_clicks ?? '',
      attrs.cpc ?? '',
      attrs.gross_revenue ?? '',
      attrs.net_revenue ?? '',
    ].join(',');
  });

  downloadCSV([header, ...rows].join('\n'), `clicks_by_referrer_${startDate}_through_${endDate}`);
}
